module.exports = __webpack_public_path__ + "static/img/WarmPlate (15).b3955cd9.png";